import { carrierIcons } from "../../../assets/icons";

export function SelectedCarrierSection({ selectedRate }) {
  return (
    <div className="flex items-center justify-between w-full">
      <div className="flex items-center gap-4">
        {/* Carrier Icon */}
        <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center rounded-lg bg-gray-100">
          {carrierIcons[selectedRate.carrierName]}
        </div>

        {/* Carrier & Service Info */}
        <div className="flex flex-col">
          <span className="text-gray-900 font-semibold text-sm truncate">
            {selectedRate.carrierName}
          </span>
          <span className="text-gray-500 text-xs truncate">{selectedRate.serviceName}</span>
        </div>
      </div>

      {/* Transit Days Badge */}
      <div className="flex flex-col items-end">
        <span className="text-gray-500 text-xs">Transit:</span>
        <span className="bg-sky-100 text-sky-800 px-2 py-0.5 rounded-full text-xs font-medium">
          {selectedRate.transitDays} day{selectedRate.transitDays > 1 ? "s" : ""}
        </span>
      </div>
    </div>
  );
}
